import React from 'react';
import classNames from 'classnames';
import qs from 'query-string';
import Highlighted from '../highlighted';
import SpinnerDots from '../spinner/dots';
import './styles.scss';

const Autocompleter = (props) => {
    const { suggestions } = props;

    const generateQuery = (facets) => {
      const queryObj = [];
      facets.forEach(facet => {
        queryObj.push(qs.stringify({
          typename: facet.label
        }));
      });

      return queryObj.join('&');
      //console.log(qs.stringify(queryObj));
    };

    const suggest = suggestions.hits && suggestions.hits.map((term, index) => {
      const itemClass = classNames({
          'autocompleter__item': true,
          'autocompleter__item--is-selected': suggestions.index === index,
        });
        
        return (
          <li
            role="option"
            className={itemClass}
            aria-selected={suggestions.index === index}
            key={index}
            onClick={() => props.handleOnSelect(term)}>
              <a href={term && term.unitId ? `/unit/${term.unitId}` : `/search?searchText=${term.label}`}>
                <span><Highlighted search={suggestions.defaultValue}>{term.label}</Highlighted></span> <span className="autocompleter__item-type">{term.suggestType}</span>
              </a>
          </li>);
    });
    
    if (!suggestions.isVisible) return null;

    return (
        <div className="autocompleter">
          <ul role="listbox"
              aria-expanded={suggestions.isVisible}
              id="listbox"
              className="autocompleter__terms">{suggest}</ul>
          {suggestions.hits.length === 0 &&
            <div className={classNames({
              'autocompleter__categories-container': true,
              'autocompleter__categories-container--is-loading': suggestions.isLoadingCategories
            })}>
              <h1 className="autocompleter__heading">Utforska kategorier</h1>
              
              {suggestions.categories &&
                <ul className="autocompleter__categories">
                  {suggestions.categories.facets[0].facetValues.map(cat => {
                    if (cat.count === 0) return null;
                    
                    return (
                      <li key={cat.code} className="autocompleter__categories-item">
                        <a href={`/search?typegroupname=${cat.label}&${generateQuery(cat.childrenFacetValues)}`}>{cat.label}</a>
                      </li>
                    );
                  })}
                </ul> 
              }
              <SpinnerDots />
            </div>
          }
        </div>
      );
};

export default Autocompleter;